import styled from 'styled-components';
import { Progress } from 'antd';

export const Container = styled.div`
  font-family: 'Roboto';
  user-select: none;
  margin: 0 0 8px 0;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  background: ${({ isRevised }) => isRevised ? '#e8f5e8' : '#ffffff'};
  border: 1px solid #e8e8e8;
  transition: all 0.2s ease;
  cursor: pointer;
  min-height: 80px;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
    transform: translateY(-2px);
    border-color: #d9d9d9;
  }

  ${({ isDragging }) => isDragging && `
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    transform: scale(1.02);
    border-color: #1890ff;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px;
  padding-bottom: 20px;
  width: 100%;
  flex: 1;
  overflow: hidden;
`;

export const MainContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
`;

export const ItemId = styled.div`
  font-size: 10px;
  font-weight: bold;
  color: #ccc;
  position: absolute;
  top: 6px;
  left: 10px;
  z-index: 1;
`;

export const UpdatedDate = styled.div`
  font-size: 9px;
  color: #999;
  position: absolute;
  bottom: 4px;
  right: 10px;
  z-index: 1;
`;

export const MenuItem = styled.div`
  position: absolute;
  padding: 6px;
  top: 4px;
  right: 4px;
  cursor: pointer;
  z-index: 2;
  border-radius: 4px;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const ItemTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #262626;
  line-height: 1.3;
  margin-top: 16px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const ItemDescription = styled.div`
  font-size: 12px;
  color: #666;
  line-height: 1.3;
  margin-top: 4px;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TasksProgress = styled.div`
  margin-top: 6px;
  width: 100%;
`;

export const TasksTooltip = styled.div`
  font-size: 11px;
  color: #666;
`;

export const PercentageContainer = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
`;

export const ProgressStyled = styled(Progress).attrs({
  strokeColor: '#52c41a',
  showInfo: false,
  size: 'small',
})`
  .ant-progress-outer {
    padding-right: 0 !important;
  }
  
  .ant-progress-inner {
    background-color: #f0f0f0;
    border-radius: 4px;
    height: 6px !important;
  }
  
  .ant-progress-bg {
    border-radius: 4px;
    height: 6px !important;
  }
`;